var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/utils/index.ts
function depthFirstSearchWidthSet(children, condition, width) {
  const c = [...children];
  (function find(cls) {
    if (!cls) return;
    for (let i = 0; i < (cls == null ? void 0 : cls.length); i++) {
      if (condition(cls[i])) {
        cls[i] = __spreadProps(__spreadValues({}, cls[i]), {
          width
        });
        return;
      }
      if (cls[i].children) {
        find(cls[i].children);
      }
    }
  })(c);
  return c;
}
function isString(data) {
  return typeof data === "string";
}
function isUndefined(data) {
  return typeof data === "undefined";
}
function isNumber(data) {
  return typeof data === "number";
}
function isFunction(data) {
  return typeof data === "function";
}
function isObject(data) {
  return Object.prototype.toString.call(data) === "[object Object]";
}
function isEmpty(data) {
  if (typeof data !== "object" || data === null) {
    return true;
  }
  if (Array.isArray(data) && data.length) {
    return false;
  }
  if (Object.keys(data).length) {
    return false;
  }
  return true;
}
function isColHidden(col) {
  return col.hideInTable || col.hidden;
}
function isReservedColumn(item) {
  return item && isObject(item) && Object.keys(item).length === 0;
}

export { depthFirstSearchWidthSet, isColHidden, isEmpty, isFunction, isNumber, isObject, isReservedColumn, isString, isUndefined };
